/*
 * @Author: SuperMrBean 330178030@qq.com
 * @Date: 2023-01-28 14:23:43
 * @LastEditors: SuperMrBean 330178030@qq.com
 * @LastEditTime: 2023-04-02 23:16:34
 * @FilePath: /open-data-admin/src/views/login/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Component, Vue } from "vue-property-decorator";
import Axios from "../../plugins/http";
@Component
export default class Login extends Vue {
  mobile: string = "";
  verifyCode: string = "";
  loading: boolean = false;
  countNum: number = 60;
  timer: any = null;
  isDisblasd: boolean = false;
  created() {
    window.localStorage.clear();
  }
  onPushSms() {
    if (this.mobile == "") {
      this.$message.error(`手机号不可为空`);
      return;
    }
    let data = {
      mobile: this.mobile.trim(),
    };
    this.loading = true;
    Axios.getSecret("/api/auth/sendSms", data).then((res: any) => {
      this.loading = false;
      if (res.data.status === 200) {
        this.$message({
          type: "success",
          message: "发送成功",
        });
        this.countDown();
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }
  countDown() {
    this.isDisblasd = true;
    this.timer = setInterval(() => {
      if (this.countNum == 0) {
        clearInterval(this.timer);
        this.countNum = 60;
        this.isDisblasd = false;
      } else {
        this.countNum--;
      }
    }, 1000);
  }
  onSubmit() {
    let { mobile, verifyCode } = this;
    if (mobile == "") {
      this.$message.error(`手机号不可为空`);
    } else if (verifyCode == "") {
      this.$message.error("验证码不可为空");
    } else {
      let data = {
        mobile: mobile.trim(),
        verifyCode,
      };
      Axios.postByJson("/api/auth/employee/login", data).then((res: any) => {
        if (res.data.status === 200) {
          window.localStorage.setItem("token", res.data.data.token);
          window.localStorage.setItem(
            "OPEN_ADMIN_USERNAME",
            res.data.data.name
          );
          window.localStorage.setItem("OPEN_ADMIN_MOBILE", mobile.trim());
          window.localStorage.setItem(
            "OPEN_ADMIN_WORK_TIME",
            `${res.data.data.workingStartTime}-${res.data.data.workingEndTime}`
          );
          window.localStorage.setItem(
            "OPEN_ADMIN_ORDER_USERID",
            res.data.data.orderRelevanceUserId
          );
          this.$router.push({ path: "/shopAdmin" });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
}
